module.exports = __webpack_public_path__ + "static/media/sq-1.b357d419.png";